var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
var localeTranslator = function (WrappedComponent, translationObject) {
    return function (props) {
        var t = useTranslation(translationObject)[0];
        return (_jsx(WrappedComponent, __assign({}, props, { translate: t })));
    };
};
export default localeTranslator;
